module.exports = __webpack_public_path__ + "img/illustrator-work-time.d489f5dd.svg";